import {
  ThemeContext,
  themeNameFromUserPreferences,
  ThemeName,
  ThemePreference,
  DarkThemePreference,
} from '@app/themes';
import { useContext } from 'react';

type ThemeFamily = 'light' | 'dark';

export const useTheme = (): [
  ThemeName,
  ThemeFamily,
  ThemePreference,
  (themePreference: ThemePreference) => void,
  DarkThemePreference,
  (darkThemePreference: DarkThemePreference) => void,
] => {
  const { themePreference, setThemePreference, darkThemePreference, setDarkThemePreference } =
    useContext(ThemeContext);
  const themeName = themeNameFromUserPreferences(themePreference, darkThemePreference);
  const themeFamily = themeName === 'light' ? 'light' : 'dark';

  return [
    themeName,
    themeFamily,
    themePreference,
    setThemePreference,
    darkThemePreference,
    setDarkThemePreference,
  ];
};
